import highchartsBasics from '@/language/en/mixins/highcharts-basics';
import exportModel from '@/language/en/mixins/export-model';
import pagesModel from '@/language/en/mixins/pages-model';
import formModel from '@/language/en/mixins/form-model';
import genderModel from '@/language/en/mixins/gender-model';
import cardsModel from '@/language/en/mixins/cards-model';
import statusModel from '@/language/en/mixins/status-model';
import filtersModel from '@/language/en/mixins/filters-model';
import sentimentModel from '@/language/en/mixins/sentiment-model';
import deviceModel from '@/language/en/mixins/device-model';
import channelModel from '@/language/en/mixins/channel-model';
import sacTypeModel from '@/language/en/mixins/sac-type-model';

export default {
  highchartsBasics,
  exportModel,
  pagesModel,
  formModel,
  genderModel,
  cardsModel,
  statusModel,
  filtersModel,
  sentimentModel,
  deviceModel,
  channelModel,
  sacTypeModel,
};
